document.addEventListener("DOMContentLoaded", function () {
    const searchContainer = document.querySelector("#main-header .ss-pill-long-btn");
    const searchInput = searchContainer.querySelector('input');
    const suggestionsContainer = document.querySelector("#main-header .suggestions-container");
    const suggestionsList = suggestionsContainer.querySelector('.suggestions-list');
    const schema = {
        foundCompaniesList: []
    }

    setListeners()

    function setListeners() {
        const stockChart = document.getElementById('stock-chart');

        searchContainer.addEventListener('click', () => {
            searchContainer.classList.add('open');
            if (schema.foundCompaniesList.length) {
                setTimeout(() => {
                    suggestionsContainer.classList.add('show');
                }, 1000)
            }
            searchInput.focus()
        })
       
        document.addEventListener('click', (e) => {
            if (!e.target.closest('#main-header')) {
                searchContainer.classList.remove('open');
                suggestionsContainer.classList.remove('show');
            }
        })

        searchInput.addEventListener('input', (e) => {
            const query = e.target.value.trim();
            if (query.length > 0) {
                makeSearchRequest(query);
            } else {
                suggestionsContainer.classList.remove('show');
            }
        })

        suggestionsContainer.addEventListener('click', (e) => {

            const isClickOnItem = e.target.closest('.item');
            const isClickOnWatchlist = e.target.closest('.add-to-watchlist');

            if (isClickOnItem) {
                const companyData = e.target.closest('.item').dataset.company;

                if (!isClickOnWatchlist) {
                    suggestionsContainer.classList.remove('show');
                    searchContainer.classList.remove('open');
                    searchInput.value = '';
                    selectStock(companyData)
                } else {
                    if (window.consentGiven === false) {
                        if (window.AuthUI && window.AuthUI.showMessage) {
                            window.AuthUI.showMessage('Login restricted. You cannot login until you accept the cookies');
                        }
                        return;
                    }
                    let company = {};
                    try {
                        company = JSON.parse(companyData);
                    } catch (e) {
                        console.error('Error parsing company data', e);
                        return;
                    }

                    let isLoggedIn = false;
                    try {
                        const sessionStr = localStorage.getItem('auth_session');
                        if (sessionStr) {
                            const sessionItem = JSON.parse(sessionStr);
                            if (sessionItem && sessionItem.expiry && Date.now() < sessionItem.expiry) {
                                isLoggedIn = true;
                            }
                        }
                    } catch (e) {
                        console.error('Error checking login status', e);
                    }

                    if (!isLoggedIn) {
                        const message = 'Log in to access watchlist';
                        if (window.WatchlistApp && window.WatchlistApp.Popup && window.WatchlistApp.Popup.showNotificationPopup) {
                            window.WatchlistApp.Popup.showNotificationPopup('Watchlist Access', message);
                        } else {
                            alert(message);
                        }
                        return;
                    }

                    if (window.WatchlistApp && window.WatchlistApp.Popup && window.WatchlistApp.Popup.showAddToWatchlistPopup) {
                        window.WatchlistApp.Popup.showAddToWatchlistPopup(company.ticker_symbol, company.company_name);
                    } else {
                        console.error('WatchlistApp.Popup module missing');
                    }
                }

            }
        })

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') selectFirstCompanyFromList()
        });
        document.addEventListener('close-search-screen', closeCenterChart);

        if (stockChart) {
            stockChart.addEventListener('componentchanged', (event) => {
                if (!event.detail || event.detail.name !== 'tradingview-universal-chart') return;
                reapplyOverlayChartSize();
            });
        }
    }

    function reapplyOverlayChartSize(attempt = 0) {
        const centerChartOverlay = document.getElementById('center-chart-overlay');
        if (!centerChartOverlay) return;

        const stockChart = document.getElementById('stock-chart');
        const component = stockChart && stockChart.components && stockChart.components['tradingview-universal-chart'];

        if (!component || !component.chart || !component.chartContainer) {
            if (attempt >= 12) return;
            setTimeout(() => reapplyOverlayChartSize(attempt + 1), 50);
            return;
        }

        // resizeChartForOverlay(true);
        const scene = document.querySelector('a-scene');
        if (scene) scene.emit('search-mode-state', true);
    }

    function selectFirstCompanyFromList() {
        const isListShown = suggestionsContainer.classList.contains('show');
        const isCompaniesFound = schema.foundCompaniesList.length > 0
        if (isListShown && isCompaniesFound) {
            selectStock(JSON.stringify(schema.foundCompaniesList[0]))
        }
    }

    async function makeSearchRequest(query) {
        const apiURL = 'https://api.palosverdestech.com/'
        try {
            const response = await fetch(`${apiURL}/tickers/search/${encodeURIComponent(query)}`);

            if (!response.ok) {
                throw new Error(`Search failed: ${response.status} ${response.statusText}`);
            }

            const data = await response.json();
            const currentResults = data.results || [];
            schema.foundCompaniesList = currentResults.slice(0, 5);
            if (schema.foundCompaniesList.length) {
                displayCompaniesList()
            } else {
                suggestionsContainer.classList.remove('show');
            }

        } catch (error) {
            console.error('Ticker search error:', error);
        }
    }

    function displayCompaniesList() {
        suggestionsContainer.classList.add('show');
        suggestionsList.innerHTML = '';

        schema.foundCompaniesList.forEach(company => {
            const item = document.createElement('div');
            item.className = 'item';
            item.dataset.company = JSON.stringify(company);
            item.innerHTML = `
                        <div class="ticker">${company.ticker_symbol}</div>
                        <div class="company">${company.company_name}</div>
                        <button class="add-to-watchlist">Add to Watchlist</button>
            `;
            suggestionsList.appendChild(item);
        })
    }

    async function selectStock(rawData) {
        window._searchStockSelected = true;
        searchContainer.classList.remove('open');
        suggestionsContainer.classList.remove('show');

        const data = JSON.parse(rawData);
        let volume = null
        let prevClose = null;

        if (data.ticker_symbol) {
            if(window.gtag) gtag('event', `Desktop_TopNav_Search`, {ticker: data.ticker_symbol});
            
            try {
                const [volumeResult, perfResult] = await Promise.all([
                    fetchVolumeData(data.ticker_symbol),
                    window.RightPanelProxyAPIManager ? 
                        window.RightPanelProxyAPIManager.create().then(m => m.fetchStockPerformance(data.ticker_symbol)) : 
                        null
                ]);
                
                volume = volumeResult;
                if (perfResult && perfResult.prevClose) {
                    prevClose = perfResult.prevClose;
                }
             } catch (err) {
                 console.warn('Error fetching extra data in search select:', err);
                 try {
                    volume = await fetchVolumeData(data.ticker_symbol);
                 } catch (e) {}
             }
        }
        const stock = {
            ticker: data.ticker_symbol,
            primary_exchange: data.exchange,
            daypart_relative_volume_percentage: volume,
            tickerDetails: {
                name: data.company_name,
                primary_exchange: data.exchange,
                previous_close: prevClose
            }
        }

        let exchange = stock.primary_exchange || 'Unknown Exchange';
        if (exchange === "New York Stock Exchange") {
            exchange = "NYSE";
        }
        const formattedTicker = `${exchange}:${stock.ticker || 'UNKNOWN'}`;
        addTickerNewsToLeftPanel(formattedTicker);


        const stockChart = document.getElementById('stock-chart');
        if (!stockChart) {
            return;
        }
        let currentDataInterval
        let currentShowEventsStatus = false
        let currentShowExtendedHours = false
        const existingUniversal = stockChart.getAttribute('tradingview-universal-chart');
        if (!existingUniversal) return

        if (existingUniversal.width != null && stockChart.dataset.chartWidth == null) {
            stockChart.dataset.chartWidth = existingUniversal.width;
        }
        if (existingUniversal.height != null && stockChart.dataset.chartHeight == null) {
            stockChart.dataset.chartHeight = existingUniversal.height;
        }
        if (existingUniversal.dataInterval) {
            currentDataInterval = existingUniversal.dataInterval
        }
        if (existingUniversal.showEvents) {
            currentShowEventsStatus = existingUniversal.showEvents
        }
        if (existingUniversal.showExtendedHours) {
            currentShowExtendedHours = existingUniversal.showExtendedHours
        }

        const universalType = existingUniversal.type ? existingUniversal.type : 'mountain'
        const dataInterval = '1D';

        stockChart.setAttribute('tradingview-universal-chart', {
            stockData: JSON.stringify(stock),
            dataInterval: dataInterval,
            type: universalType,
            showEvents: currentShowEventsStatus,
            showExtendedHours: currentShowExtendedHours,
        });

        const scene = document.querySelector('a-scene');

        if (scene) {
            scene.emit('data-interval', { interval: dataInterval });
        }

        const rightAverageVolumeEl = document.querySelector('#right-average-volume');
        const rightAverageVolumeBarEl = document.querySelector('#right-average-volume .active-bar');
        if (rightAverageVolumeEl && rightAverageVolumeBarEl) {
            const stockVolume = stock.daypart_relative_volume_percentage || 0;
            const width = Math.min(Math.max(0, stockVolume / 2), 100)
            rightAverageVolumeBarEl.style.width = `${width}%`;
            rightAverageVolumeEl.classList.add('initialized')
            if (dataInterval === '1D' || dataInterval === '1d') {
                rightAverageVolumeEl.classList.add('show')
            } else {
                rightAverageVolumeEl.classList.remove('show')
            }
        }

        if (scene) {
            scene.emit('stock-selected', stock);
        }
        switchToPerformanceTab();
        setTimeout(() => {
            addChartToCenterPanel();
        }, 500);
    }

    function addChartToCenterPanel() {
        try {
            const stockChart = document.getElementById('stock-chart');
            const parentId = stockChart && stockChart.parentElement ? stockChart.parentElement.id : null;
            console.debug('[search-handler] addChartToCenterPanel start', {
                overlayExists: !!document.getElementById('center-chart-overlay'),
                stockChartVisible: stockChart ? stockChart.getAttribute('visible') : undefined,
                stockChartPos: stockChart ? stockChart.getAttribute('position') : undefined,
                stockChartParentId: parentId
            });
        } catch (_) { /* no-op */ }
        
        
        document.body.dataset.isSearchMode = 'true';

        if (document.body.classList.contains('watchlist-mode')) {
            if (window.WatchlistApp && window.WatchlistApp.Manager && window.WatchlistApp.Manager.suspendWatchlistMode) {
                window.WatchlistApp.Manager.suspendWatchlistMode();
            }
        }

        const centerPanelContainer = document.getElementById('center-panel-container');
        if (centerPanelContainer) {
            centerPanelContainer.setAttribute('visible', 'false');
        }


        const rightWrapper = document.querySelector('.right-wrapper');
        if (rightWrapper && rightWrapper.classList.contains('financials-expanded')) {
             if (window.toggleRightPanelFullscreen) {
                 window.toggleRightPanelFullscreen();
             }
        }

        const chartWrapper = document.querySelector('.chart-wrapper');
        if (!chartWrapper) {
            console.warn('chart-wrapper not found');
            return;
        }
        chartWrapper.style.display = 'block';
        
        let centerChartOverlay = document.getElementById('center-chart-overlay');
        if (!centerChartOverlay) {
            centerChartOverlay = document.createElement('div');
            centerChartOverlay.id = 'center-chart-overlay';
            centerChartOverlay.classList.add('center-chart-overlay');
            chartWrapper.appendChild(centerChartOverlay);
            console.debug('[search-handler] Created #center-chart-overlay and appended to .chart-wrapper');
        } else {
            centerChartOverlay.className = 'center-chart-overlay';
        }

        const liveChartTab = document.querySelector('.live-chart-tab');

        if (!liveChartTab) {
            console.warn('live-chart-tab not found');
            return;
        }

        const tabs = document.querySelectorAll("#right-container .right-panel-nav-tab");
        let activeTabIndex = 0;
        tabs.forEach((tab, index) => {
            if (tab.classList.contains('show')) {
                activeTabIndex = index;
            }
        });
        centerChartOverlay.dataset.activeTabIndex = activeTabIndex.toString();

        const isAlreadyInOverlay = centerChartOverlay.contains(liveChartTab);

        const originalParent = isAlreadyInOverlay ?
            (centerChartOverlay.dataset.originalParentId ?
                document.getElementById(centerChartOverlay.dataset.originalParentId) :
                document.getElementById('right-container')) :
            liveChartTab.parentNode;

        if (isAlreadyInOverlay) {
            liveChartTab.classList.remove('show');
            liveChartTab.classList.add('search-mode-live-chart-tab');

            let closeButton = centerChartOverlay.querySelector('.center-chart-close-button');
            if (!closeButton) {
                closeButton = createCloseButton();
                centerChartOverlay.appendChild(closeButton);
            }

            setTimeout(() => {
                const stockWrapper = liveChartTab.querySelector('#stock-wrapper');
                const rightLiveChart = liveChartTab.querySelector('#right-live-chart');
                const timeRangeWrapper = liveChartTab.querySelector('.time-range-wrapper');
                const chartContainer = liveChartTab.querySelector('.chart-container');
                const rightAverageVolume = liveChartTab.querySelector('#right-average-volume');

                if (stockWrapper) stockWrapper.classList.add('search-mode-stock-wrapper');
                if (rightLiveChart) rightLiveChart.classList.add('search-mode-right-live-chart');
                if (timeRangeWrapper) {
                    timeRangeWrapper.classList.add('search-mode-time-range-wrapper');
                    
                    const intervalButtons = timeRangeWrapper.querySelectorAll('.item');
                    intervalButtons.forEach(btn => {
                        btn.classList.remove('active');
                        if (btn.getAttribute('data-range') === '1D') {
                            btn.classList.add('active');
                        }
                    });
                }
                if (chartContainer) chartContainer.classList.add('search-mode-chart-container');
                if (rightAverageVolume) rightAverageVolume.classList.add('search-mode-right-average-volume');
            }, 100);

            return;
        }

        const centerLiveChartWrapper = document.createElement('div');
        centerLiveChartWrapper.className = 'center-live-chart-wrapper';

        const centerChartContainer = document.createElement('div');
        centerChartContainer.className = 'right-container center-chart-container';

        liveChartTab.classList.remove('show');

        centerChartContainer.appendChild(liveChartTab);

        const mainButtons = document.querySelector('#right-container .main-buttons');
        if (mainButtons) {
             centerChartOverlay.dataset.mainButtonsOriginalParentId = mainButtons.parentNode.id;
             centerChartContainer.appendChild(mainButtons);
             mainButtons.classList.add('search-mode-main-buttons');
        }

        const settingsButton = document.querySelector('.right-panel-tab-dropdown .header-buttons .button.settings') || document.querySelector('#right-container .button.settings');
        
        if (settingsButton) {
             centerChartOverlay.dataset.settingsButtonMoved = 'true';
             
             if (mainButtons) {
                 mainButtons.appendChild(settingsButton);
             } else {
                 centerChartContainer.appendChild(settingsButton);
             }
             
             settingsButton.classList.add('search-mode-settings-button');
        }

        centerLiveChartWrapper.appendChild(centerChartContainer);
        centerChartOverlay.appendChild(centerLiveChartWrapper);

        const closeButton = createCloseButton();
        centerChartOverlay.appendChild(closeButton);

        liveChartTab.classList.add('search-mode-live-chart-tab');

        let resizeFrame = null;
        let lastWidth = null;

        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                if (entry.target === centerLiveChartWrapper) {
                    const newWidth = entry.contentRect.width;
                    if (newWidth !== lastWidth) {
                        lastWidth = newWidth;
                        if (resizeFrame) {
                            cancelAnimationFrame(resizeFrame);
                        }
                        resizeFrame = requestAnimationFrame(() => {
                            resizeFrame = null;
                        });
                    }
                }
            }
        });
        resizeObserver.observe(centerLiveChartWrapper);
        centerChartOverlay.resizeObserver = resizeObserver;

        const scene = document.querySelector('a-scene');
        if (scene) scene.emit('search-mode-state', true);


        setTimeout(() => {
            const stockWrapper = liveChartTab.querySelector('#stock-wrapper');
            const rightLiveChart = liveChartTab.querySelector('#right-live-chart');
            const timeRangeWrapper = liveChartTab.querySelector('.time-range-wrapper');

            if (stockWrapper) {
                stockWrapper.classList.add('search-mode-stock-wrapper');
            }

            if (rightLiveChart) {
                rightLiveChart.classList.add('search-mode-right-live-chart');
            }

            if (timeRangeWrapper) {
                timeRangeWrapper.classList.add('search-mode-time-range-wrapper');
            }

            const chartContainer = liveChartTab.querySelector('.chart-container');
            if (chartContainer) {
                chartContainer.classList.add('search-mode-chart-container');
            }
            const rightAverageVolume = liveChartTab.querySelector('#right-average-volume');
            if (rightAverageVolume) {
                rightAverageVolume.classList.add('search-mode-right-average-volume');
            }

            resizeChartForOverlay(true);

        }, 200);
        const timeRangeWrapper = liveChartTab.querySelector('.time-range-wrapper');
        if (timeRangeWrapper) {
            setupCenterTimeRangeControls(timeRangeWrapper);

            setTimeout(() => {
                const intervalButtons = timeRangeWrapper.querySelectorAll('.item');
                intervalButtons.forEach(btn => {
                    btn.classList.remove('active');
                    if (btn.getAttribute('data-range') === '1D') {
                        btn.classList.add('active');
                    }
                });
            }, 100);
        }

        if (originalParent) {
            centerChartOverlay.dataset.originalParentId = originalParent.id || '';
            centerChartOverlay.dataset.originalParentClass = originalParent.className || '';
        }
        centerChartOverlay.dataset.liveChartTab = 'moved';
    }

    function createCloseButton() {
        const closeButton = document.createElement('div');
        closeButton.className = 'center-chart-close-button';

        const closeIcon = document.createElement('img');
        closeIcon.src = './desktop_assets/cross.svg';
        closeIcon.alt = 'Close';

        closeButton.appendChild(closeIcon);

        closeButton.addEventListener('click', () => {
            closeCenterChart();
        });
        return closeButton;
    }

    function closeCenterChart() {
        const centerChartOverlay = document.getElementById('center-chart-overlay');        
        const event = new CustomEvent('close-search-screen');
        document.dispatchEvent(event);

        const scene = document.querySelector('a-scene');
        if (scene) scene.emit('search-mode-state', false);

        if (!centerChartOverlay) {
            console.warn('center-chart-overlay not found');
            return;
        }

        const liveChartTab = document.querySelector('.live-chart-tab');
        if (!liveChartTab) {
            console.warn('live-chart-tab not found');
            return;
        }

        const activeTabIndex = centerChartOverlay.dataset.activeTabIndex;

        const originalParentId = centerChartOverlay.dataset.originalParentId;
        const originalParentClass = centerChartOverlay.dataset.originalParentClass;
        let originalParent = null;
        if (originalParentId) {
            originalParent = document.getElementById(originalParentId);
        } else if (originalParentClass) {
            originalParent = document.querySelector(originalParentClass);
        }

        if (!originalParent) {
            const rightContainer = document.getElementById('right-container');
            if (rightContainer) {
                originalParent = rightContainer;
            }
        }

        const rightContainer = document.getElementById('right-container');
        if (rightContainer && liveChartTab) {
            rightContainer.insertBefore(liveChartTab, rightContainer.querySelector('.main-buttons')); 
            
            // resizeChartForOverlay(false);
            
            liveChartTab.classList.remove('search-mode-live-chart-tab');
            
            const rightLiveChart = liveChartTab.querySelector('#right-live-chart');
            if (rightLiveChart) rightLiveChart.classList.remove('search-mode-right-live-chart');
            
            const stockWrapper = liveChartTab.querySelector('#stock-wrapper');
            if (stockWrapper) stockWrapper.classList.remove('search-mode-stock-wrapper');
            
            const rightAverageVolume = liveChartTab.querySelector('#right-average-volume');
            if (rightAverageVolume) rightAverageVolume.classList.remove('search-mode-right-average-volume');
            
            const timeRangeWrapper = liveChartTab.querySelector('.time-range-wrapper');
            if (timeRangeWrapper) timeRangeWrapper.classList.remove('search-mode-time-range-wrapper');
            
            const chartContainer = liveChartTab.querySelector('.chart-container');
            if (chartContainer) chartContainer.classList.remove('search-mode-chart-container');
        }

        const settingsButton = centerChartOverlay.querySelector('.button.settings') || document.querySelector('.main-buttons .button.settings');
        if (settingsButton) {
            const headerButtons = document.querySelector('.right-panel-tab-dropdown .header-buttons');
            if (headerButtons) {
                 if (headerButtons.firstChild) {
                    headerButtons.insertBefore(settingsButton, headerButtons.firstChild);
                 } else {
                    headerButtons.appendChild(settingsButton);
                 }
                  settingsButton.classList.remove('search-mode-settings-button');
             }
        }

        const mainButtons = centerChartOverlay.querySelector('.main-buttons');
        if (mainButtons) {
            const originalParentId = centerChartOverlay.dataset.mainButtonsOriginalParentId || 'right-container';
            const originalParent = document.getElementById(originalParentId);
            if (originalParent) {
                  originalParent.appendChild(mainButtons);
                  mainButtons.classList.remove('search-mode-main-buttons');
             }
        }
        if (centerChartOverlay.resizeObserver) {
            centerChartOverlay.resizeObserver.disconnect();
            delete centerChartOverlay.resizeObserver;
        }

        centerChartOverlay.remove();

        window._searchStockSelected = false;
        delete document.body.dataset.isSearchMode;
        
        if (document.body.classList.contains('watchlist-mode')) {
             if (window.WatchlistApp && window.WatchlistApp.Manager && window.WatchlistApp.Manager.resumeWatchlistMode) {
                window.WatchlistApp.Manager.resumeWatchlistMode();
            }
        }

        setTimeout(() => {
            const menuItems = document.querySelectorAll("#right-container .menu .item");
            const liveChartTab = Array.from(menuItems).find(item => item.textContent.trim() === 'Live Chart');
            
            if (liveChartTab) {
                liveChartTab.click();
            } else if (menuItems.length > 0) {
                 menuItems[0].click();
            }
            window.StockStormDesktop4Scale?.resizeRightPanelChart?.();
            window.dispatchEvent(new Event('resize'));
        }, 300); 

        const centerPanelContainer = document.getElementById('center-panel-container');
        if (centerPanelContainer) {
            centerPanelContainer.setAttribute('visible', 'true');
        }



    }

    function setupCenterTimeRangeControls(timeRangeWrapper) {
        const newTimeRangeWrapper = timeRangeWrapper.cloneNode(true);
        timeRangeWrapper.parentNode.replaceChild(newTimeRangeWrapper, timeRangeWrapper);

        const intervalButtons = newTimeRangeWrapper.querySelectorAll('.item');
        const rightAverageVolumeEl = document.querySelector('#right-average-volume');

        intervalButtons.forEach((button) => {
            button.addEventListener("click", () => {
                intervalButtons.forEach(btn => btn.classList.remove("active"));
                button.classList.add("active");
                const selectedInterval = button.getAttribute("data-range");

                const stockChart = document.getElementById('stock-chart');
                if (!stockChart || !selectedInterval) return;

                stockChart.setAttribute('tradingview-universal-chart', {
                    dataInterval: selectedInterval
                });

                if (rightAverageVolumeEl && rightAverageVolumeEl.classList.contains('initialized')) {
                    if (selectedInterval === '1D') {
                        rightAverageVolumeEl.classList.add('show');
                    } else {
                        rightAverageVolumeEl.classList.remove('show');
                    }
                }
            });
        });

        const scene = document.querySelector('a-scene');
        if (scene) {
            scene.addEventListener('data-interval', (e) => {
                if (e.detail && e.detail.interval) {
                    intervalButtons.forEach(btn => {
                        if (btn.getAttribute("data-range") === e.detail.interval) {
                            btn.classList.add("active");
                        } else {
                            btn.classList.remove("active");
                        }
                    });
                }
            });
        }
    }

    function switchToPerformanceTab() {
        const tabs = document.querySelectorAll("#right-container .right-panel-nav-tab");
        const tabDropdownItems = document.querySelectorAll('.right-panel-tab-dropdown .tab-dropdown-menu .dropdown-item');
        const tabDropdownBtn = document.querySelector('.right-panel-tab-dropdown .tab-dropdown-btn');

        if (tabs.length < 2) {
            console.warn('Performance tab not found');
            return;
        }

        const allTabs = document.querySelectorAll(".right-panel-nav-tab");
        allTabs.forEach(tab => tab.classList.remove('show'));

        const performanceTab = document.querySelector(".right-panel-nav-tab.performance-tab");
        if (performanceTab) {
            performanceTab.classList.add('show');
        } else {
            console.warn('Performance tab element not found');
        }

        if (tabDropdownBtn) {
            const labelElement = tabDropdownBtn.querySelector('.dropdown-label');
            if (labelElement) {
                labelElement.textContent = 'Performance';
            }
        }

        tabDropdownItems.forEach((item, index) => {
            if (index === 1) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });

        const event = new CustomEvent('tab-changed', { detail: { tabIndex: 1 } });
        document.dispatchEvent(event);
    }

    async function fetchVolumeData(tickerSymbol) {
        const protocol = window.location.protocol;
        const hostname = window.location.host;
        const proxyBaseURL = `${protocol}//${hostname}/proxy-pvtech?url=`;
        const baseURLAPI = 'https://api.palosverdestech.com/tickers/details/metrics/daypart-rvol/';
        const useProxy = false
        const url = useProxy ? `${proxyBaseURL}${encodeURIComponent(baseURLAPI + tickerSymbol)}` : (baseURLAPI + tickerSymbol) ;

        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const jsonData = await response.json();
        if (jsonData) {
            return jsonData.daypart_relative_volume_percentage || null;
        }
        return null
    }
})
